export enum AttendanceReportType {
  StudentAverageReport = 1,
  ClassSectionAverageReport = 2,
  StudentsAbsentDaysReport = 3
}
